import { render } from "./IconAlignTextLeft.vue?vue&type=template&id=6969e18a"
import script from "./IconAlignTextLeft.vue?vue&type=script&lang=js"
export * from "./IconAlignTextLeft.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__